export const updatePaginatedRowsData = (
  currentRowsData = {},
  workflowGroupId,
  pageNumber,
  newRows,
  totalPages,
  totalEntries
) => {
  const existingGroupData = currentRowsData[workflowGroupId] || {};

  return {
    ...currentRowsData,
    [workflowGroupId]: {
      ...existingGroupData,
      current_page: pageNumber,
      total_entries: totalEntries,
      total_pages: totalPages,
      [pageNumber]: newRows,
    },
  };
};

export const updateCellValue = (
  rowsData,
  approverGroupId,
  page,
  rowId,
  columnKey,
  newValue
) => {
  const group = rowsData?.[approverGroupId];
  if (!group) return rowsData;

  const pageRows = group?.[page];
  if (!pageRows) return rowsData;

  const rowIndex = pageRows.findIndex((r) => r.id === rowId);
  if (rowIndex === -1) return rowsData;

  const updatedRow = {
    ...pageRows[rowIndex],
    row_data: {
      ...pageRows[rowIndex].row_data,
      [columnKey]: {
        ...pageRows[rowIndex].row_data[columnKey],
        value: newValue,
      },
    },
  };

  const updatedPageRows = [...pageRows];
  updatedPageRows[rowIndex] = updatedRow;

  return {
    ...rowsData,
    [approverGroupId]: {
      ...group,
      [page]: updatedPageRows,
    },
  };
};

export const updateRowData = (
  rowsData,
  approverGroupId,
  page,
  rowId,
  rowData
) => {
  const group = rowsData?.[approverGroupId];
  if (!group) return rowsData;

  const pageRows = group?.[page];
  if (!pageRows) return rowsData;

  const rowIndex = pageRows.findIndex((r) => r.id === rowId);
  if (rowIndex === -1) return rowsData;

  const updatedRow = {
    ...pageRows[rowIndex],
    error: rowData.error,
    error_count: rowData.error_count,
    row_data: {
      ...(pageRows[rowIndex].row_data || {}),
      ...(rowData.row_data || {}),
    },
  };

  const updatedPageRows = [...pageRows];
  updatedPageRows[rowIndex] = updatedRow;

  return {
    ...rowsData,
    [approverGroupId]: {
      ...group,
      [page]: updatedPageRows,
    },
  };
};

export const getCellValidations = (cell, value) => {
  const validations = cell?.validations || [];

  if (!validations.length) {
    return {
      hasError: false,
      hasWarning: false,
      tooltipMessage: value || cell?.value,
    };
  }

  const errorValidation = validations.find((v) => v.severity === "error");
  const warningValidation = validations.find((v) => v.severity === "warning");

  const activeValidation = errorValidation || warningValidation;

  return {
    hasError: !!errorValidation,
    hasWarning: !errorValidation && !!warningValidation,
    tooltipMessage: activeValidation?.message || value || cell?.value,
  };
};
